import i18next from "i18next";
import { Alert, Button, Card } from "react-bootstrap";
import { useStellantisActions } from "src/store/StellantisStore";
import { GoAlert } from "react-icons/go";
import { MdOutlineWarningAmber } from "react-icons/md";

type Props = {
  source?: string;
}

const StellantisVehicleEmptyState: React.FC<Props> = ({ source = 'lista_veicoli' }) => {
  const { openRequestQuoteModal } = useStellantisActions();

  return (
    <Card className="mt-4">
      <Card.Body>
        <Alert variant="info" className="d-flex align-items-center justify-content-between p-4">
          <div className="d-flex align-items-center gap-2 text-center">
            <MdOutlineWarningAmber size={44} />
            <h5>{i18next.t('stellantis_vehicle_empty_state_message')}</h5>
          </div>
          <Button variant="outline-info" className="fw-bold" onClick={() => openRequestQuoteModal(undefined, source)}>{i18next.t('request_quote')}</Button>
        </Alert>
      </Card.Body>
    </Card>
  )
}

export default StellantisVehicleEmptyState
